<div class="full-details-container">
    <header class="d-flex justify-content-between align-items-center">
        <h5>Details</h5>
        <div class="header-btns d-flex">
            <button [class.active]="activeButton == HeaderButton.Details" (click)="changeActiveButton(HeaderButton.Details)">
                <img src="../../../../../assets/icons/ng_v3/map-details.svg" />
            </button>
            <button [class.active]="activeButton == HeaderButton.Schematic" (click)="changeActiveButton(HeaderButton.Schematic)">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.875 6.1875C5.80698 6.1875 6.5625 5.43198 6.5625 4.5C6.5625 3.56802 5.80698 2.8125 4.875 2.8125C3.94302 2.8125 3.1875 3.56802 3.1875 4.5C3.1875 5.43198 3.94302 6.1875 4.875 6.1875Z" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4.875 15.1875C5.80698 15.1875 6.5625 14.432 6.5625 13.5C6.5625 12.568 5.80698 11.8125 4.875 11.8125C3.94302 11.8125 3.1875 12.568 3.1875 13.5C3.1875 14.432 3.94302 15.1875 4.875 15.1875Z" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13.125 6.1875C14.057 6.1875 14.8125 5.43198 14.8125 4.5C14.8125 3.56802 14.057 2.8125 13.125 2.8125C12.193 2.8125 11.4375 3.56802 11.4375 4.5C11.4375 5.43198 12.193 6.1875 13.125 6.1875Z" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4.875 6.1875V11.8125" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13.125 6.1875V7.5C13.125 8.32845 12.4534 9 11.625 9H6.375C5.54657 9 4.875 9.67155 4.875 10.5V11.8125" stroke="#171717" stroke-opacity="0.8" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <button [class.active]="activeButton == HeaderButton.Sphere" (click)="changeActiveButton(HeaderButton.Sphere)">
                <img src="../../../../../assets/icons/ng_v3/map-sphere.svg" />
            </button>
        </div>
        <button class="close-btn d-flex justify-content-center align-items-center" (click)="closeModal()">
            ✖
        </button>
    </header>
    <div [style.overflowY]="activeButton == HeaderButton.Details ? 'scroll' : 'hidden'" class="full-details-body">
        <div *ngIf="activeButton == HeaderButton.Details" class="img-container">
            <img *ngIf="dt.image" src="{{ dt.image }}" alt="Download icon" />
            <img class="no-img" *ngIf="!dt.image" src="../../../../../assets/no-image.png" alt="Download icon" />
        </div>
        <div *ngIf="activeButton == HeaderButton.Schematic" class="schematic-container">
        </div>
        <div #streetViewContainer *ngIf="activeButton == HeaderButton.Sphere" [hidden]="!showStreetView" class="street-view-container">
        </div>
        <div *ngIf="activeButton == HeaderButton.Sphere" [style.backgroundColor]="'#000'" [hidden]="showStreetView" class="street-view-container">      
        </div>
        <div class="details">
            <div class="slrn-status-row d-flex justify-content-between align-items-center">
                <div class="bd-info d-flex justify-content-between align-items-center">
                    <div class="bd-img">
                        <img src="../../../../../assets/icons/ng_v3/map-dt-icon.svg" />
                    </div>
                    <div class="slrn">
                        <h5>Distribution Substation</h5>
                        <span>{{ dt.slrn | hasValue}}</span>
                    </div>
                </div>
                <div class="status d-flex align-items-center justify-content-center gap-1">
                    <img src="../../../../../assets/icons/ng_v3/active-icon.svg" />
                    <span>Active</span>
                </div>
            </div>
            <div *ngIf="activeButton == HeaderButton.Details" class="asset-details">
                <h4>Asset Details</h4>
                <div class="details-row d-flex justify-content-between align-items-center" [class.copied]="slrnCopied">
                    <span class="label">SLRN</span>
                    <div class="d-flex justify-content-center align-items-center gap-2">
                        <span class="value">{{ dt.slrn | hasValue}}</span>
                        <img (click)="copySlrn()" class="copy" src="../../../../../assets/icons/ng_v3/copy-black.svg" />
                    </div>
                </div>
                <div class="details-row d-flex justify-content-between align-items-center">
                    <span class="label">Rating</span>
                    <span class="value">{{ dt.rating | hasValue}}</span>
                </div>
                <div class="details-row d-flex justify-content-between align-items-center">
                    <span class="label">Meter Status</span>
                    <span class="value">{{ dt.meterStatus | hasValue}}</span>
                </div>
                <div class="details-row d-flex justify-content-between align-items-center">
                    <span class="label">Type</span>
                    <div class="dt-type d-flex align-items-center justify-content-center gap-2">
                        <img src="../../../../../assets/icons/ng_v3/IconEarth.svg" />
                        <span class="value">{{ dt.type | hasValue}}</span>
                    </div>
                </div>
                <div class="details-row d-flex justify-content-between align-items-center">
                    <span class="label">Address</span>
                    <span class="value">{{ dt.address | hasValue}}</span>
                </div>
                <div class="details-row d-flex justify-content-between align-items-center" [class.copied]="coordinatesCopied">
                    <span class="label">Coordinates</span>
                    <div class="d-flex align-items-center justify-content-center gap-2">
                        <div>
                            <span class="value">{{ dt.latitude | hasValue}},</span>
                            <span class="value">{{ dt.longitude | hasValue}}</span>
                        </div>
                        <img (click)="copyCoordinates()" class="copy" src="../../../../../assets/icons/ng_v3/copy-black.svg" />
                    </div>
                </div>
            </div>
            <div *ngIf="activeButton == HeaderButton.Details" class="connected-accounts">
                <h4>Number of Connected Assets</h4>
                <span class="total-acc">{{ dt.connectedAssets.length  }}</span>
            </div>
        </div>
    </div>
</div>